import { InvestigatorGuard } from './investigator-guard';
import { LabReportsComponent } from './lab-reports.component';
import { KitInventoryComponent } from './kitinventory/kit-inventory.component';
import { DocumentsWithChildCategoriesComponent } from './documents-with-child-categories.component';
import { GeneralDocumentsGuard } from './general-documents-guard';
import { DocumentsTabsComponent } from './documents-tabs.component';
import { SingleCategoryDocumentsGuard } from './single-category-documents-guard';
import { DocumentsComponent } from './documents.component';
import { Routes } from '@angular/router';
import { SelectedSiteResolver } from '../sites/selected-site-resolver';
import { SiteSpecificCategoriesResolver } from './site-specific-categories-resolver';
import { WorkspaceLevelLayoutComponent } from '../layout/workspace-level-layout.component';
import { subjectsRoutes } from './subjects/subjects.routes';
import { microbiologyDataRoutes } from '../on-screen-results';
import { standardTestResultsRoutes } from '../on-screen-results';
import { InvestigatorNavigationComponent } from './navigation/investigator-navigation.component';
import { InvestigatorLevelComponent } from './investigator-level.component';
import { PageTitle } from '../core/page-title';
import { investigatorDocumentsActivityHandler } from '../activities/navigation-activity/handlers/investigator/investigator-documents-activity-handler';
import { WorkspaceDrawerBehaviorResolver } from '../layout/workspace-drawer-behavior-resolver';
import { navigationActivity } from '../activities/navigation-activity/navigation-activity-resolver';
import { investigatorDefaultActivityHandler } from '../activities/navigation-activity/handlers/investigator/investigator-default-activity-handler';
import { routeData, routeParams } from '../shared/route-helpers';
import { InvestigatorEQueryTabsComponent } from './e-queries/investigator-e-query/investigator-e-query-tabs.component';
import { EQueryTab } from '../e-queries/models/e-query-tab.enum';
import { InvestigatorAwaitingEQueriesComponent } from './e-queries/investigator-e-query/awaiting/investigator-awaiting-e-queries.component';
import { InvestigatorSubmittedEQueriesComponent } from './e-queries/investigator-e-query/submitted/investigator-submitted-e-queries.component';
import { defaultActivityHandler } from '../activities/navigation-activity/handlers/default-activity-handler';

export const investigatorRoutes: Routes = [
    {
        path: `:${routeParams.studyUrlParam}/:${routeParams.siteUrlParam}`,
        canActivate: [InvestigatorGuard],
        resolve: {
            [routeData.selectedSite]: SelectedSiteResolver,
            [routeData.siteSpecificCategories]: SiteSpecificCategoriesResolver,
            [routeData.drawerBehavior]: WorkspaceDrawerBehaviorResolver,
        },
        component: InvestigatorLevelComponent,
        children: [
            {
                path: '',
                component: WorkspaceLevelLayoutComponent,
                children: [
                    {
                        path: '',
                        redirectTo: 'lab-reports', //TODO: ashevnin Default page should be specified somewhere,
                        pathMatch: 'full'
                    },
                    {
                        path: '',
                        children: [
                            ...subjectsRoutes,
                            {
                                path: `documents/:${routeParams.categoryId}`,
                                data: {
                                    title: PageTitle.getInvestigatorTitle('Documents'),
                                    ...investigatorDocumentsActivityHandler('categoryId'),
                                },
                                resolve: { ...navigationActivity },
                                children: [
                                    {
                                        path: '',
                                        component: DocumentsComponent,
                                        pathMatch: 'full',
                                        canActivate: [SingleCategoryDocumentsGuard]
                                    },
                                    {
                                        path: `:${routeParams.childCategoryId}`,
                                        data: {
                                            ...investigatorDocumentsActivityHandler('childCategoryId')
                                        },
                                        resolve: { ...navigationActivity },
                                        component: DocumentsTabsComponent,
                                        children: [
                                            {
                                                path: '',
                                                canActivate: [GeneralDocumentsGuard],
                                                component: DocumentsWithChildCategoriesComponent,
                                                pathMatch: 'full'
                                            },
                                        ]
                                    }
                                ]
                            },
                            {
                                path: 'lab-reports',
                                data: {
                                    title: PageTitle.getInvestigatorTitle('Lab Reports'),
                                    ...investigatorDefaultActivityHandler('View Lab Reports'),
                                },
                                resolve: { ...navigationActivity },
                                component: LabReportsComponent
                            }
                        ]
                    },
                    {
                        path: 'on-screen-results',
                        children: [
                            ...standardTestResultsRoutes,
                            ...microbiologyDataRoutes
                        ]
                    },
                    {
                        path: 'kit-inventory',
                        data: {
                            title: PageTitle.getInvestigatorTitle('Kit Inventory'),
                            ...investigatorDefaultActivityHandler('View Kit Inventory Report'),
                        },
                        resolve: { ...navigationActivity },
                        component: KitInventoryComponent
                    },
                    {
                        path: `e-queries`,
                        data: {
                            title: PageTitle.getInvestigatorTitle('eQueries'),
                        },
                        component: InvestigatorEQueryTabsComponent,
                        children: [
                            {
                                path: '',
                                redirectTo: 'awaiting',
                                pathMatch: 'full'
                            },
                            {
                                path: 'awaiting',
                                component: InvestigatorAwaitingEQueriesComponent
                            },
                            {
                                path: 'submitted',
                                component: InvestigatorSubmittedEQueriesComponent
                            },
                        ]
                    },
                    {
                        path: '**',
                        redirectTo: 'lab-reports' //TODO: ashevnin Default page should be specified somewhere
                    },
                    {
                        path: '',
                        component: InvestigatorNavigationComponent,
                        outlet: 'navigation'
                    },
                ]
            }
        ]
    }
];
